import { useState } from 'react';

import { useQuery } from '@apollo/client';

import { GET_LIST_VIDEO_DIFFICULTIES } from '~/graphql/discover';
import useIsSSR from '~/hooks/useIsSSR';
import { Query } from '~/types';

export const useDifficultyTranslations = () => {
  const [difficultyTranslations, setDifficultyTranslations] = useState<
    Record<string, string> | undefined
  >(undefined);
  const isSSR = useIsSSR();

  const { loading } = useQuery<Pick<Query, 'listVideoDifficulties'>>(GET_LIST_VIDEO_DIFFICULTIES, {
    onCompleted: (data) => {
      const obj: Record<string, string> = {};
      data?.listVideoDifficulties?.forEach((item) => {
        if (item?.id && item?.title) {
          obj[item?.id] = item?.title;
        }
      });
      setDifficultyTranslations(obj);
    },
    skip: isSSR,
  });

  return {
    translations: difficultyTranslations,
    loading,
  };
};
